/**
 * 파일 블록 (FP-4) — BlockNote `file` 블록 렌더/직렬화.
 * { type:"file", props:{ url, name? }, content:[], children:[] }
 * 파일명 + 다운로드 링크 카드. (url 없으면 placeholder)
 */

import { neutralizeUrl } from "../../utils/url.js";

function esc(s) {
  return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}

export function fileBlockToElement(block) {
  if (typeof document === "undefined") throw new Error("fileBlockToElement: DOM 필요");
  const el = document.createElement("div");
  el.className = "block";
  el.dataset.type = "file";
  if (block && block.id != null) el.dataset.id = String(block.id);
  el.__props = block && block.props ? { ...block.props } : {};
  el.__children = block && Array.isArray(block.children) ? block.children : [];

  const props = el.__props;
  const wrap = document.createElement("div");
  wrap.className = "lumir-file";
  wrap.setAttribute("contenteditable", "false");

  if (props.url) {
    const name = props.name || String(props.url).split("/").pop() || "파일";
    wrap.innerHTML =
      '<span class="lf-icon">📄</span>' +
      `<span class="lf-name">${esc(name)}</span>` +
      `<a class="lf-download" href="${esc(neutralizeUrl(props.url))}" download target="_blank" rel="noopener noreferrer">다운로드</a>`;
  } else {
    wrap.innerHTML = '<div class="lumir-file-placeholder">파일 없음</div>';
  }
  el.appendChild(wrap);
  return el;
}

export function fileElementToBlock(el) {
  const block = {};
  if (el.dataset.id != null) block.id = el.dataset.id;
  block.type = "file";
  block.props = el.__props || {};
  // 파일형 블록: blocknote 구조상 content 키 없음(no content)
  block.children = el.__children || [];
  return block;
}
